import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactGA from "react-ga";

import { setTitleAndScrollToTop } from "../actions";

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class Page extends React.Component
{
	componentDidMount()
	{
		this.props.setTitleAndScrollToTop( this.props.title );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( this.props.pageUrl );
		}
		
	} // function componentDidMount()
	
	render()
	{
		const { className = "white", before, after, children } = { ...this.props };
		
		return <article>
			{before}
			<section className={className}>
				{children}
			</section>
			{after}
		</article>;
		
	} // function render()
	
} // class

Page.propTypes = {
	title: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object ] ).isRequired,
	pageUrl: PropTypes.string.isRequired,
	className: PropTypes.string,
	before: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.node ] ),
	after: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.node ] ),
	children: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.node ] )
};

Page = connect(
	null,
	mapDispatchToProps
)( Page );

export default Page;